module.exports = __webpack_public_path__ + "img/example1.038116ce.png";